import { useQuery } from 'react-query';

import type { QueryFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';
import { isObject } from '@frontend/utils';

import type { InternalQuotesOverviewQueryKeyType } from './getInternalQuotesOverviewQueryKey';
import { getInternalQuotesOverviewQueryKey } from './getInternalQuotesOverviewQueryKey';
import type {
  InternalQuotesOverviewQueryParams,
  InternalQuotesOverviewResponse,
} from './types';

export const useGetInternalQuotesOverview: QueryFunction<
  InternalQuotesOverviewResponse,
  [],
  InternalQuotesOverviewQueryKeyType,
  InternalQuotesOverviewQueryParams
> = ({ requestOptions, queryOptions, query } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    queryKey: getInternalQuotesOverviewQueryKey(query),
    queryFn: ({ signal }) =>
      request<InternalQuotesOverviewResponse>('/quotes/internal_overview', {
        init: { signal },
        query: isObject(query) ? query : {},
      }),
    ...queryOptions,
  });
};
